import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  ReturnPage as CoreFlightReturnPage,
  setSortOption,
} from "@b2bportal/core-flights";
import { SortOptionEnum } from "@overrides/types";
export const ReturnPage = (
  coreProps: React.ComponentProps<typeof CoreFlightReturnPage>
) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSortOption(SortOptionEnum.Price));
  }, []);

  return <CoreFlightReturnPage {...coreProps} />;
};
